import employeesApi from "../../api/employees";

const state = {
  unsubmittedFaculty: [],
  workloadFaculty: [],
  faculty: []
};

const getters = {};

const actions = {
  getUnsubmittedFaculty(context, timePeriodId) {
    return new Promise((resolve, reject) => {
      employeesApi
        .getUnsubmittedFaculty(timePeriodId)
        .then(function(response) {
          context.commit("updateUnsubmittedFaculty", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getWorkloadFaculty(context) {
    return new Promise((resolve, reject) => {
      employeesApi
        .getWorkloadFaculty()
        .then(function(response) {
          context.commit("updateWorkloadFaculty", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getFaculty(context) {
    return new Promise((resolve, reject) => {
      employeesApi
        .getFaculty()
        .then(function(response) {
          context.commit("updateFaculty", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};

const mutations = {
  updateUnsubmittedFaculty(state, value) {
    state.unsubmittedFaculty = value;
  },
  updateWorkloadFaculty(state, value) {
    state.workloadFaculty = value;
  },
  updateFaculty(state, value) {
    state.faculty = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
